import script from "./DonePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DonePanel.vue?vue&type=script&setup=true&lang=js"

import "./DonePanel.vue?vue&type=style&index=0&id=8a8bb802&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a8bb802"]])

export default __exports__